import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Api} from '../../../smoothr-web-app-core/api/api';
import Order from '../../../smoothr-web-app-core/models/Order';
import {RepositoryService} from '../../../smoothr-web-app-core/services/repository/repository.service';
import {TranslateService} from '@ngx-translate/core';
import {BehaviorSubject, Subscription} from 'rxjs';
import {OrderUtils} from '../../../smoothr-web-app-core/utils/order-utils';
import {SignInPage} from '../../pages/sign-in/sign-in.page';
import {SignUpPage} from '../../pages/sign-up/sign-up.page';
import {Router} from '@angular/router';
import {axiosErrorToMessage, numberToCurrency} from '../../../smoothr-web-app-core/utils/utils';
import {AnalyticsService} from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import {FormControl} from '@angular/forms';
import PromoCode from 'src/smoothr-web-app-core/models/PromoCode';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ModalController} from '@ionic/angular';
import {AlertInfoModalComponent} from '../alert-info-modal/alert-info-modal.component';

@Component({
	selector: 'app-promo-code',
	templateUrl: './promo-code.component.html',
	styleUrls: ['promo-code.component.scss']
})
export class PromoCodeComponent {
	public vitalCodeInput = new FormControl();
	public loading$ = new BehaviorSubject<boolean>(false);
	inputCode: PromoCode = null;
	_order: Order;
	@Input() set order(order: Order) {
		this._order = order;
		if (this._order && this._order.promoCode && this._order.promoCode.code) {
			this.inputCode = this._order.promoCode;
			this.vitalCodeInput.patchValue(this._order.promoCode.code);
		}
		// if (value) {
		// 	this.inputCode = value;
		// 	this.vitalCodeInput.patchValue(value);
		// }
	}
	// @Input() order: Order;
	@Output() vitalCode = new EventEmitter<string>();
	@Output() successOrder = new EventEmitter<Order>();
	constructor(
		private snackBar: MatSnackBar,
		private analytics: AnalyticsService,
		private modalCtrl: ModalController,
		private translate: TranslateService,
		private repository: RepositoryService
	) {}

	ngOnInit() {}
	// loadCode() {
	// 	this.inputCode = this.vitalCodeInput?.value;
	// 	this.vitalCode.emit(this.vitalCodeInput?.value);
	// }
	deleteCode() {
		this.inputCode = null;
	}
	async loadCode() {
		if (!this.vitalCodeInput?.value || this.vitalCodeInput?.value.replace(' ', '').length === 0) {
			await AlertInfoModalComponent.show(
				this.modalCtrl,
				this.translate.instant('promo_code.not_valid'),
				null,
				null,
				this.translate.instant('change_time_alert.cancel')
			);
			return;
		}
		this.loading$.next(true);
		try {
			const promoCode = (
				await Api.getPromoCode({
					code: this.vitalCodeInput?.value,
					venue: this._order.venue
				})
			).data;
			promoCode.mov = +promoCode.mov;
			if (OrderUtils.orderTotalPrice(this._order, false, false) < promoCode.mov) {
				await AlertInfoModalComponent.show(
					this.modalCtrl,
					null,
					this.translate.instant('promo_code.mov_not_reached'),
					null,
					this.translate.instant('change_time_alert.cancel')
				);
				this.loading$.next(false);

				return;
			}
			try {
				try {
					const orderCopy = JSON.parse(JSON.stringify(this._order));
					orderCopy.promoCode = promoCode;
					orderCopy.userUid = this.repository.customer.uid;
					orderCopy.orderAt = null;
					await Api.applyPromoCode(orderCopy);
				} catch (e) {
					this.loading$.next(false);

					this.snackBar.open(axiosErrorToMessage(this.translate, e), null, {duration: 400});
					return;
				}
				this.successOrder.emit(
					OrderUtils.applyPromo(this.translate, this.repository._venue, this._order, promoCode, this.analytics)
				);
				this.inputCode = promoCode;
				this.loading$.next(false);
			} catch (e) {
				console.log(e);

				this.loading$.next(false);
			}
		} catch (e) {
			console.log(e);
			this.loading$.next(false);
			if (e.response.status === 404) {
				await AlertInfoModalComponent.show(
					this.modalCtrl,
					null,
					this.translate.instant('promo_code.not_valid'),

					null,
					this.translate.instant('change_time_alert.cancel')
				);
				return;
			}
			return;
		}
	}
}
